/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { COMPONENT_NAME_PREFIX } from '../constants';
const elementName = `${COMPONENT_NAME_PREFIX}view-switcher`;
const classes = {
    ROOT: 'forge-view-switcher',
    VIEW_HIDDEN: 'forge-view-switcher__view--hidden',
    VIEW_SWITCHER_SLIDE: 'slide',
    VIEW_SWITCHER_FADE: 'fade'
};
const selectors = {
    ROOT: `.${classes.ROOT}`,
    DEFAULT_SLOT: 'slot:not([name])',
    VIEW_HIDDEN: `.${classes.VIEW_HIDDEN}`
};
const attributes = {
    INDEX: 'index',
    ANIMATION_TYPE: 'animation-type'
};
const numbers = {
    DEFAULT_TRANSITION_DURATION: 500
};
export const VIEW_SWITCHER_CONSTANTS = {
    elementName,
    attributes,
    classes,
    selectors,
    numbers
};
export var ViewAnimationDirection;
(function (ViewAnimationDirection) {
    ViewAnimationDirection["Left"] = "left";
    ViewAnimationDirection["Right"] = "right";
})(ViewAnimationDirection || (ViewAnimationDirection = {}));
/** @deprecated Use `ViewSwitcherAnimation` type instead. */
export var ViewSwitcherAnimationType;
(function (ViewSwitcherAnimationType) {
    ViewSwitcherAnimationType["None"] = "none";
    ViewSwitcherAnimationType["Slide"] = "slide";
    ViewSwitcherAnimationType["Fade"] = "fade";
})(ViewSwitcherAnimationType || (ViewSwitcherAnimationType = {}));
